import { render, staticRenderFns } from "./DefaultPrintFormItem.vue?vue&type=template&id=0010c98c&scoped=true"
import script from "./DefaultPrintFormItem.vue?vue&type=script&lang=js"
export * from "./DefaultPrintFormItem.vue?vue&type=script&lang=js"
import style0 from "./DefaultPrintFormItem.vue?vue&type=style&index=0&id=0010c98c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010c98c",
  null
  
)

export default component.exports